var blProductDetailUtil	=
{
	buildRenderData:
		function( itemData, colorYearTogether )
		{
			const	detail			= itemData.dmItemDetail;
			const	itemEx			= detail.dmItem;
			const	itemBasic		= itemEx.dmBasic;
			const	{ typeItem, strItemName, strItemNoFull, strCatStrV2, nYear, nYearTo, nPartCnt, nFigCnt, idColorDefault, imgDefault }	
									= itemBasic;
			const 	{ fWeight, fDimX, fDimY, fDimZ, nInstructions } 
									= itemEx;
			const	idColor			= itemData.idColor;

			let		data			= {};

			// Breadcrumbs
			let 	breadcrumbs = [];
			let		strCatBuild	= "";

			breadcrumbs.push( { content: blapp.util.getTypeName( typeItem, false ), link: blapp.url2.getCatalogBrowseUrl( typeItem + ":" ) } );
			_.forEach( 
				blapp.category.getV2ListByCatStr( strCatStrV2 )
			,	( cat ) =>
				{
					strCatBuild	= ( strCatBuild == "" ? ( typeItem + ":" ) : ( strCatBuild + "." ) ) + cat.idCateV2;
					breadcrumbs.push( { content: cat.strName, link: blapp.url2.getCatalogBrowseUrl( strCatBuild ) } );
				}
			);
			breadcrumbs.push( { content: strItemNoFull } );
			data.breadcrumbs	= breadcrumbs;

			// Images
			let		images		= [];
			let		showingImg	= null;

			if ( itemBasic.bColorEnabled )
			{
				let		colorImg	= null;
				if ( itemEx.mapColorImgs != null )
					colorImg	= itemEx.mapColorImgs[ idColor ];
				
				if ( colorImg != null )
				{
					showingImg	= colorImg;
				}
				else
				{
					showingImg	= _.clone( itemBasic.imgDefault );
					showingImg.idColor			= idColor;
					showingImg.bNotAvailable	= true;
				}

				images.push( 
					{
						id:		images.length
					,	large:	blapp.url2.getCatalogItemImgUrl( showingImg, "D" )
					,	small:	blapp.url2.getCatalogItemImgUrl( showingImg, "T1" )
					}
				);					

				if ( itemEx.arrAddlImgs != null )
				{
					_.forEach(
						itemEx.arrAddlImgs
					,	( img ) =>
						{
							if ( img.idColor == -1 || img.idColor == idColor )
							{
								images.push( 
									{
										id:		images.length
									,	large:	blapp.url2.getCatalogItemImgUrl( img, "D" )
									,	small:	blapp.url2.getCatalogItemImgUrl( img, "T1" )
									}
								);							
							}
						}
					);
				}
			}
			else
			{
				let	img	= itemBasic.imgDefault;

				images.push( 
					{
						id:		images.length
					,	large:	blapp.url2.getCatalogItemImgUrl( img, "D" )
					,	small:	blapp.url2.getCatalogItemImgUrl( img, "T1" )
					}
				);

				showingImg	= img;

				if ( detail.dmItemAssoc1 != null )
				{
					img	= detail.dmItemAssoc1.imgDefault;

					if ( img != null && !img.bNotAvailable && img.bHasFile )
					{
						images.push( 
							{
								id:		images.length
							,	large:	blapp.url2.getCatalogItemImgUrl( img, "D" )
							,	small:	blapp.url2.getCatalogItemImgUrl( img, "T1" )
							}
						);					
					}
				}

				if ( detail.dmItemAssoc2 != null )
				{
					img	= detail.dmItemAssoc2.imgDefault;

					if ( img != null && !img.bNotAvailable && img.bHasFile )
					{
						images.push( 
							{
								id:		images.length
							,	large:	blapp.url2.getCatalogItemImgUrl( img, "D" )
							,	small:	blapp.url2.getCatalogItemImgUrl( img, "T1" )
							}
						);					
					}
				}

				if ( itemEx.arrAddlImgs != null )
				{
					_.forEach(
						itemEx.arrAddlImgs
					,	( img ) =>
						{
							images.push( 
								{
									id:		images.length
								,	large:	blapp.url2.getCatalogItemImgUrl( img, "D" )
								,	small:	blapp.url2.getCatalogItemImgUrl( img, "T1" )
								}
							);							
						}
					);
				}

				if ( typeItem == "M" && detail.arrConsistsOfPreview )
				{
					let	cateMap = 	{ 
										"636":	0
									,	"913":	1
									,	"915":	1
									,	"847":	1
									,	"16":	1
									,	"914":	2
									,	"238":	2
									,	"606":	2
									,	"917":	3
									,	"485":	3
									,	"911":	4
									,	"916":	4
									,	"484":	4
									};

					let	coImages	= [];

					_.forEach(
						detail.arrConsistsOfPreview
					,	( item ) =>
						{
							let	order	= cateMap[ item.dmItem.dmItem.strCatStr ];

							if ( order != null )
							{
								coImages.push( 
									{
										large:	blapp.url2.getCatalogItemImgUrl( item.dmItem.dmImg, "D" )
									,	small:	blapp.url2.getCatalogItemImgUrl( item.dmItem.dmImg, "T1" )
									,	order:	order
									}
								);
							}
						}
					);

					coImages.sort( ( l, r ) => l.order - r.order );
					_.forEach( coImages, ( ci ) => images.push( { id: images.length, large: ci.large, small: ci.small } ) );
				}
			}
			if ( images.length == 0 )
				images.push( { id: 0, large: blapp.url2.getNoImageUrl( typeItem ), small: blapp.url2.getNoImageUrl( typeItem ) } )
			data.images		= images;
			data.colorImg	= showingImg;

			// Colors
			data.selectedColor	= blapp.color.get( idColor );

			// Stats
			const	dimUnit	= typeItem == "P" ? "stud" : "cm";

			data.stats		=	[];

			data.stats.push( {label: 'Item no', content: strItemNoFull + ( itemBasic.strAltNo ? ( " (" + itemBasic.strAltNo + ")" ) : "" ) } );

			if ( itemBasic.bColorEnabled )
				data.stats.push( {label: 'Mold Year', content: nYear > 0 ? ( nYearTo > nYear ? `${nYear} - ${nYearTo}` : `${nYear}` ) : "-" } );
			else
				data.stats.push( {label: 'Year released', content: nYear > 0 ? ( nYearTo > nYear ? `${nYear} - ${nYearTo}` : `${nYear}` ) : "-" } );

			if ( itemBasic.bColorEnabled && colorYearTogether )
				data.stats.push( {label: 'Color Year', content: itemData.nYearFrom > 0 ? ( itemData.nYearTo > itemData.nYearFrom ? `${itemData.nYearFrom} - ${itemData.nYearTo}` : `${itemData.nYearFrom}` ) : "-" } );

			data.stats.push( {label: 'Weight (g)', content: fWeight } );

			if ( itemBasic.bColorEnabled && !colorYearTogether )
				data.stats.push( {label: 'Color Year', content: itemData.nYearFrom > 0 ? ( itemData.nYearTo > itemData.nYearFrom ? `${itemData.nYearFrom} - ${itemData.nYearTo}` : `${itemData.nYearFrom}` ) : "-" } );

			data.stats.push( {label: `Size (${dimUnit})`, content:  ( fDimX || fDimY || fDimZ ) ? `${fDimX} x ${fDimY} x ${fDimZ}` : "-" } );

			if ( idColor >= 0 && itemEx.mapPCCs && itemEx.mapPCCs[ idColor ] )
				data.stats.push( {label: `Color Code`, content:  itemEx.mapPCCs[ idColor ].replace( /,/g, ", " ) } );

			if ( typeItem == 'S' )
				data.stats.push( {label: 'Instructions Books', content: nInstructions} );

			// Co-brandings
			let		cobrandings	= [];
			if ( itemEx.strCoBrandList )
			{
				_.forEach(
					itemEx.strCoBrandList.split( "," )
				,	( strCoBrand ) =>
					{
						let	cb	= blapp.cobrand.get( parseInt( strCoBrand ) );

						if ( cb )
							cobrandings.push( { name: cb.strCoBrandName, link: blapp.url2.getSearchUrl(cb.strCoBrandName) } );
					}
				);
			}
			data.cobrandings	= cobrandings;

			// decorated items
			if ( typeItem == "P" )
			{
				if ( itemData.nTotalSameMouldCount > 0 )
					data.decorated	= { cnt: itemData.nTotalSameMouldCount, list: itemData.arrSameMouldItems, idColor: idColor };
				else if ( detail.nTotalSameMouldCount > 0 )
					data.decorated	= { cnt: detail.nTotalSameMouldCount, list: detail.arrSameMouldItems, idColor: -1 };
				else
					data.decorated	= null;
			}
			else
			{
				data.decorated		= null;
			}

			if ( !_.isEmpty( detail.arrSimiliarItemsFromSearch ) )
			{
				if ( typeItem == "S" )
				{
					let	similiarNumbers	= [];
					let	similiarNames	= [];

					_.forEach(
						detail.arrSimiliarItemsFromSearch
					,	( i ) =>
						{
							if ( i.dmItem.strItemNo == itemBasic.strItemNo )
								similiarNumbers.push( i );
							else
								similiarNames.push( i );
						}
					);

					data.similiarNumbers	= similiarNumbers;
					data.similiarNames		= similiarNames;
				}	
				else
				{
					data.recommendedItems	= detail.arrSimiliarItemsFromSearch;
				}
			}

			return data;
		}
};

export default blProductDetailUtil;